module.exports = __webpack_public_path__ + "static/10-677392d63e2b4dd92bf511e0b2e2afa5.jpg";